import { render, staticRenderFns } from "./ReportSubmitPage.vue?vue&type=template&id=09a2e6e0&scoped=true"
import script from "./ReportSubmitPage.vue?vue&type=script&lang=js"
export * from "./ReportSubmitPage.vue?vue&type=script&lang=js"
import style0 from "./ReportSubmitPage.vue?vue&type=style&index=0&id=09a2e6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a2e6e0",
  null
  
)

export default component.exports